import React, { useState } from 'react';
import { Button, Card, Space, Table, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { PRIMARY_COLOR } from '../upload.constants';
import { Operation, UploadType } from '../upload.types';
import { Storage } from 'react-jhipster';
import axios from 'axios';

const { Text, Title } = Typography;

interface TemplateDownloadProps {
  selectedOperation: Operation;
  ecoleId?: string;
  anneeScolaireId?: string;
}

const TemplateDownload: React.FC<TemplateDownloadProps> = ({ selectedOperation, ecoleId, anneeScolaireId }) => {
  const [loading, setLoading] = useState(false);

  const token = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');
  const [apiUrl, setApiUrl] = useState(`/api/eleves/download?ecoleId=${ecoleId}&anneeScolaireId=${anneeScolaireId}`);
  if (!selectedOperation) {
    return null;
  }
  const downloadFile = () => {
    setLoading(true);
    axios({
      url: apiUrl,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
      responseType: 'blob',
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'élèves.xlsx');
      document.body.appendChild(link);
      link.click();
      setLoading(false);
    });
  };
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
      <Title level={4}>Téléchargez le modèle</Title>
      <Card style={{ marginTop: 20, borderColor: PRIMARY_COLOR }}>
        <Space direction="vertical" align="center" style={{ width: '100%' }}>
          <Text>{selectedOperation.instructions}</Text>
          <Text type="secondary">Colonnes requises: {selectedOperation.schema.join(', ')}</Text>

          {selectedOperation.label === UploadType.INSCRIPTION ? (
            <Button
              type="primary"
              href={selectedOperation.templateUrl}
              download
              style={{
                backgroundColor: PRIMARY_COLOR,
                borderColor: PRIMARY_COLOR,
                marginBottom: 20,
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row-reverse',
                justifyContent: 'center',
                fontWeight: '500',
                gap: 4,
              }}
            >
              Télécharger le template Excel
              <DownloadOutlined style={{ fontSize: 16 }} />
            </Button>
          ) : (
            <Button
              type="primary"
              onClick={downloadFile}
              disabled={loading}
              loading={loading}
              download
              style={{
                backgroundColor: PRIMARY_COLOR,
                borderColor: PRIMARY_COLOR,
                marginBottom: 20,
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row-reverse',
                justifyContent: 'center',
                fontWeight: '500',
                gap: 4,
              }}
            >
              Exporter / Télécharger le template
              <DownloadOutlined style={{ fontSize: 16 }} />
            </Button>
          )}

          <div style={{ width: '100%', overflowX: 'auto' }}>
            <Text strong style={{ marginBottom: 8 }}>
              Exemple de fichier attendu :
            </Text>
            <Table
              bordered
              size="small"
              pagination={false}
              columns={selectedOperation.schema.map(column => ({
                title: column,
                dataIndex: column,
                key: column,
                width: 150,
                render: text => (
                  <div
                    style={{
                      height: 20,
                      backgroundColor: '#f5f5f5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Text type="secondary">{text || `0`}</Text>
                  </div>
                ),
              }))}
              dataSource={[
                {
                  'Ancien Matricule': 'E1',
                  'Nouveau Matricule': ' ',
                  Nom: 'FAYE',
                  Prénom: 'Mariama',
                  Classe: 'CE1',
                  'Nom du Parent': 'TALL',
                  'Prénom du Parent': 'Seynabou',
                  'Téléphone du Parent': '123456789',
                  'Montant de Scolarité': '150000',
                },
                {
                  'Ancien Matricule': 'E2',
                  'Nouveau Matricule': ' ',
                  Nom: 'MENDY',
                  Prénom: 'Simon',
                  Classe: '3EMEB',
                  'Nom du Parent': 'MENDY',
                  'Prénom du Parent': 'JEAN',
                  'Téléphone du Parent': '123456789',
                  'Montant de Scolarité': '170000',
                },
                {
                  'Ancien Matricule': 'E3',
                  'Nouveau Matricule': ' ',
                  Nom: 'FALL',
                  Prénom: 'Tacko',
                  Classe: '4EMC',
                  'Nom du Parent': 'MBENGUE',
                  'Prénom du Parent': 'Alimatou',
                  'Téléphone du Parent': '123456789',
                  'Montant de Scolarité': '170000',
                },
              ]}
              style={{ marginTop: 16 }}
            />
          </div>

          <div
            style={{
              marginTop: 16,
              padding: 8,
              backgroundColor: '#fafafa',
              border: '1px solid #d9d9d9',
              borderRadius: 4,
              textAlign: 'left',
              width: '100%',
            }}
          >
            <Text type="secondary">
              <ul style={{ margin: 0, paddingLeft: 20 }}>
                <li>Le fichier doit être au format Excel (.xlsx)</li>
                <li>Conservez les en-têtes de colonnes exactement comme indiqués</li>
                <li>Ne modifiez pas l&apos;ordre des colonnes</li>
                <li>Remplissez toutes les colonnes obligatoires</li>
              </ul>
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default TemplateDownload;
